<template>
  <ion-page>
    <ion-header />
    <ion-content
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
      :style="{ '--background': backgroundColor, '--background-color': backgroundColor }"
    >
      <div class="page-transition-content" data-page-transition>
        <slot></slot>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonContent } from '@ionic/vue';
import { isIosNativeOnly } from '@/utils/platform-check';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  components: {
    IonPage,
    IonHeader,
    IonContent,
  },
  props: {
    showFooter: {
      type: Boolean,
      default: false,
    },
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#f6f5f1',
    },
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
  async mounted() {
    await lockToPortrait();
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>

<style scoped>
ion-footer {
  --border-color: transparent;
  --background: #f2efed;
  --ion-color-base: transparent !important;
}

ion-toolbar {
  --background: transparent !important;
}

ion-content {
  /* Background color is now set dynamically via prop */
}

.footer-md::before {
  display: none;
}

.page-transition-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
